import React from "react";

const ConfirmModal = ({
  show,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  onConfirm,
  onClose,
  loading = false,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "primary"
}) => {
  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ zIndex: 1055 }}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content shadow border-0">
            <div className="modal-header bg-light">
              <h5 className="modal-title fw-bold text-dark">{title}</h5>
              <button
                type="button"
                className="btn-close"
                disabled={loading}
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body py-4">
              <p className="mb-0 text-secondary">{message}</p>
            </div>
            <div className="modal-footer bg-light">
              <button
                type="button"
                className="btn btn-secondary px-4"
                disabled={loading}
                onClick={onClose}
              >
                {cancelText}
              </button>
              <button
                type="button"
                className={`btn btn-${variant} px-4`}
                disabled={loading}
                onClick={onConfirm}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Processing...
                  </>
                ) : (
                  confirmText
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmModal;
